import { render, staticRenderFns } from "./expiredfilerightclick.vue?vue&type=template&id=45c846aa&"
import script from "./expiredfilerightclick.vue?vue&type=script&lang=js&"
export * from "./expiredfilerightclick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports